import React from 'react';

import fetch from '../../fetch';


import utils from '../../../utils';

import { Icon, Tag } from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function () {

    }
}

const headers = utils.columns([
    { type: 'selection' },
    { key: '$index', label: '序号', width: 30 },
    {
        key: 'reportType', label: '报告类型', width: 80, render: (value) => value ===
            1 ? '全校' : value === 2 ? '学院' : ''
    },
    {
        key: 'targetType', label: '对象类型', width: 80, render: (value) => value ===
            0 ? '专业' : value === 1 ? '教师' : value === 2 ? '课程' : value === 3 ? '班级' : value === 4 ?
                '学生' : value === 5 ? '部门' : value === 6 ? '团队' : ''
    },
    { key: 'orgName', label: '归属部门', width: 80 },
    { key: 'reportName', label: '报告名称', width: 80 },
    { key: 'batchNo', label: '批次', width: 80 },
    { key: 'status', label: '状态', width: 80, render: (value) => value === 1 ? <Tag color='#722ed1'>生成中</Tag>  : <Tag color='#52c41a'>已完成</Tag> },
    { key: 'createTime', label: '生成时间', width: 100 },
    {
        key: '', label: '浏览下载', width: 50, render: (d, row) => {
            return <a type="primary" style={{ width: '100%' }} onClick={() => {
                window.open(`${fetch.base}zgcp/report/print/${row.id}`, '_blank')
            }}>
                <Icon type="eye"></Icon>
                在线预览</a>
        }
    },
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    let params = []
    if (keywords['sort'] != '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('zgcp/report/query?' + params.join('&'), keywords)
        .then(response => {
            return response.payload.data;
        })
        .then(data => (Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        })));
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection = () => {
    return DataGrid.selections;
}

const getSelectionData = () => {
    return DataGrid.selectData;
}

const getTargetByObj = (id) => {
    return fetch.get(`zgcp/report/getTargetByObj/${id}`)
        .then(response => response.payload.data)
        .then(result => {
            const data = transform(utils.tree(result));
            const maps = codes(result);
            return {
                data,
                maps
            }
        })
}

const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + '',
            type: d.level
        };

        if (d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

export default {
    querySearch,
    headers,
    onSelect,
    onSelectData,
    setRefresh,
    getSelection,
    getSelectionData,
    getTargetByObj
}